// https://developers.cloudflare.com/turnstile/reference/testing/
//
// The Turnstile SITE key is environment-specific, but this SPA is built once and the
// same bundle is served to every environment. So the key is supplied at RUNTIME by
// nginx (see sweb `docker/prod/nginx/40-env-config.sh`), which writes `/env-config.js`
// from the `TURNSTILE_SITEKEY` container env var (set per-environment by the deploy's
// docker-compose). `index.html` loads that file before the app bundle, exposing
// `window.__APP_CONFIG__`. Dev is pointed at Cloudflare's test key (which pairs with the
// dev backend's test secret); staging/production use the real key.
//
// Optional build-time override (Vue CLI bakes VUE_APP_* at build): VUE_APP_TURNSTILE_SITEKEY.

// Fallback used only when neither a runtime nor a build-time value is provided.
const PROD_TURNSTILE_SITEKEY = "0x4AAAAAAALlyNINW8VWWcmv";

const DEFAULT_TURNSTILE_URL =
  "https://challenges.cloudflare.com/turnstile/v0/api.js?onload=onloadTurnstileCallback";
const DEFAULT_TURNSTILE_RESET_TIMEOUT = 295; // Defaulting to 295 seconds

// Runtime config injected by nginx (window.__APP_CONFIG__), if present.
function runtimeConfig() {
  if (typeof window !== "undefined" && window.__APP_CONFIG__) {
    return window.__APP_CONFIG__;
  }
  return {};
}

// Precedence: runtime-injected value (per-env) → build-time override → prod default.
export const turnstileSiteKey =
  runtimeConfig().turnstileSiteKey ||
  process.env.VUE_APP_TURNSTILE_SITEKEY ||
  PROD_TURNSTILE_SITEKEY;

// Get turnstile URL if exist in .env (VUE_APP_TURNSTILE_URL)
var turnstileURLVariable = DEFAULT_TURNSTILE_URL;
if (process.env.VUE_APP_TURNSTILE_URL) {
  turnstileURLVariable = process.env.VUE_APP_TURNSTILE_URL;
}
export const turnstileURL = turnstileURLVariable;

// Get turnstile reset timeout if exist in .env (VUE_APP_TURNSTILE_RESET_TIMEOUT)
var turnstileResetTimeoutVariable = DEFAULT_TURNSTILE_RESET_TIMEOUT;
if (process.env.VUE_APP_TURNSTILE_RESET_TIMEOUT) {
  turnstileResetTimeoutVariable = parseInt(
    process.env.VUE_APP_TURNSTILE_RESET_TIMEOUT,
    10
  );
}
export const turnstileResetTimeout = turnstileResetTimeoutVariable;
